<template>
  <div>
    <!-- CARİ BİLGİLERİ -->
    <b-row>
      <b-col>
        <vs-card>

          <div v-if="itemDisabled == true">
            <b-row style="padding: 10px">
              <span>
                <b-form @submit.prevent>
                  <b-row style="margin-bottom: 10px">
                    <b-col lg="6" sm="12">
                      <vs-card>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="İşlem Türü" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>

                          <b-col cols="7" align-self="center">
                            <v-select v-model="islemTuru" label="title" :options="option" placeholder="İşlem Türü"
                              @input="selectedOption" />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="İade ve Arızalı Sebep" label-for="h-first-name"
                              style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <v-select v-model="iadeSebep" label="title" :options="islemTuruKontrol == 'Rafta Arızalı'
                              ? optionIade2
                              : islemTuruKontrol == 'Satın Alma İade'
                                ? optionIade3
                                : islemTuruKontrol == 'Arızalı Ürün'
                                  ? optionIade4
                                  : optionIade
                              " placeholder="İade ve Arızalı Sebep" @input="sifirla" />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="İade Şekli" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <v-select v-model="iadeSekli" label="title" :options="islemTuruKontrol == 'Rafta Arızalı' ||
                              islemTuruKontrol == 'Satın Alma İade'
                              ? optionIadeSekil2
                              : optionIadeSekil
                              " placeholder="İade Şekli" @input="iadeValidate" />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center" v-if="masrafValidate == 'true'">
                            <b-form-group label="Masraf" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7" v-if="masrafValidate == 'true'">
                            <b-form-input id="masraf" placeholder="Masraf" v-model="masraf" />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px" v-if="raftaArizaliValidate == 'false'">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Teslim Alan Personel" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <v-select v-model="hareketACT" label="EMPLOYEENAME" :options="teslimAlanPersonel"
                              placeholder="Teslim Alan" />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px" v-if="gondpersonelValidate == 'true'">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Ürünü İsteyen Personel" label-for="h-first-name"
                              style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <v-select v-model="gonderenpersonel" label="EMPLOYEENAME" :options="teslimAlanPersonel"
                              placeholder="İsteyen Personel" />
                          </b-col>
                        </b-row>

                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Tedarikçi Seçimi" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <vue-autosuggest v-model="query2" style="width: 100%" :suggestions="filteredOptions2"
                              :get-suggestion-value="getSuggestionValue2" :input-props="{
                                id: 'autosuggest__input',
                                class: 'form-control',
                                placeholder: 'Tedarikçi Adı'
                              }" @input="onInputChange2">
                              <template slot-scope="{ suggestion }">
                                <div class="
                                    d-flex
                                    align-items-center
                                    my-suggestion-item
                                  ">
                                  <div class="detail ml-50 my-suggestion-item">
                                    <b-card-text class="mb-0">
                                      {{ suggestion.item.ACTNAME }}
                                    </b-card-text>
                                  </div>
                                </div>
                              </template>
                            </vue-autosuggest>
                          </b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                    <b-col lg="6" sm="12">
                      <vs-card>
                        <b-row style="margin-bottom: 10px" v-if="raftaArizaliValidate == 'false'">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Cari Adı" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7" align-self="center">
                            <vue-autosuggest v-model="query" style="width: 100%" :suggestions="filteredOptions"
                              :get-suggestion-value="getSuggestionValue" :input-props="{
                                id: 'autosuggest__input',
                                class: 'form-control',
                                placeholder: 'Cari Adı'
                              }" @input="onInputChange">
                              <template slot-scope="{ suggestion }">
                                <div class="
                                    d-flex
                                    align-items-center
                                    my-suggestion-item
                                  ">
                                  <div class="detail ml-50 my-suggestion-item">
                                    <b-card-text class="mb-0">
                                      {{ suggestion.item.ACTNAME }}
                                    </b-card-text>
                                  </div>
                                </div>
                              </template>
                            </vue-autosuggest>
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Yıl" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>

                          <b-col cols="7" align-self="center">
                            <v-select v-model="yil" label="title" :options="optionYil" placeholder="1 Yıl" />
                          </b-col>
                        </b-row>
                        <b-row align-h="end" style="margin-bottom: 10px">
                          <b-col cols="7" align-self="center">
                            <vs-button style="border-radius: 5px; width: 100%" type="gradient" @click="faturaSec()"
                              icon="search" color="danger">Fatura Seç</vs-button>
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Açıklama" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <vs-textarea label="(En fazla 500 karakter)" v-model="aciklama" v-on:keyup="countdown2"
                              maxlength="500" />
                            <p class="text-right text-small" v-bind:class="{ 'text-danger': hasError2 }">
                              {{ remainingCount2 }}
                              <span v-if="hasError2" v-bind:class="{ 'text-danger': hasError2 }">
                                karakter sayısını aştınız</span>
                            </p>
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px" v-if="itemDisabled == false">
                          <b-col cols="2" align-self="center">
                            <b-form-group label="Resim Ekle" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="5" align-self="center">
                            <input type="file" accept="image/*" @change="onFileChange" id="file-input" />
                          </b-col>
                          <b-col cols="5" align-self="center">
                            <vs-button color="primary" type="gradient" icon="image" style="border-radius: 5px"
                              @click="dosyaEkle()">Ekle</vs-button>
                          </b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>
                </b-form>
              </span>
            </b-row>
          </div>
          <div v-else>
            <b-row style="padding: 10px">
              <span>
                <b-form @submit.prevent>
                  <b-row style="margin-bottom: 10px">
                    <b-col lg="6" sm="12">
                      <vs-card>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="İşlem Türü" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7" align-self="center">
                            <v-select v-model="islemTuru" label="title" :options="option" placeholder="İşlem Türü"
                              @input="selectedOption" disabled />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="İade ve Arızalı Sebep" label-for="h-first-name"
                              style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <v-select v-model="iadeSebep" label="title" :options="islemTuruKontrol == 'Rafta Arızalı'
                              ? optionIade2
                              : islemTuruKontrol == 'Satın Alma İade'
                                ? optionIade3
                                : islemTuruKontrol == 'Arızalı Ürün'
                                  ? optionIade4
                                  : optionIade
                              " placeholder="İade ve Arızalı Sebep" @input="sifirla" disabled />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="İade Şekli" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <v-select v-model="iadeSekli" label="title" :options="islemTuruKontrol == 'Rafta Arızalı' ||
                              islemTuruKontrol == 'Satın Alma İade'
                              ? optionIadeSekil2
                              : optionIadeSekil
                              " placeholder="İade Şekli" @input="iadeValidate" disabled />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center" v-if="masrafValidate == 'true'">
                            <b-form-group label="Masraf" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7" v-if="masrafValidate == 'true'">
                            <b-form-input id="masraf" placeholder="Masraf" v-model="masraf" disabled />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px" v-if="raftaArizaliValidate == 'false'">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Teslim Alan Personel" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <v-select v-model="hareketACT" label="EMPLOYEENAME" :options="teslimAlanPersonel"
                              placeholder="Teslim Alan" disabled />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px" v-if="gondpersonelValidate == 'true'">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Ürünü İsteyen Personel" label-for="h-first-name"
                              style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <v-select v-model="gonderenpersonel" label="EMPLOYEENAME" :options="teslimAlanPersonel"
                              placeholder="İsteyen Personel" disabled />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Tedarikçi Seçimi" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <b-form-input id="masraf" v-model="query2" disabled />
                          </b-col>
                        </b-row>
                      </vs-card>
                    </b-col>
                    <b-col lg="6" sm="12">
                      <vs-card>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Cari Adı" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7" align-self="center">
                            <b-form-input id="masraf" v-model="query" disabled />
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Yıl" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7" align-self="center">
                            <v-select v-model="yil" label="title" :options="optionYil" placeholder="1 Yıl" disabled />
                          </b-col>
                        </b-row>
                        <b-row align-h="end" style="margin-bottom: 10px">
                          <b-col cols="5"> </b-col>
                          <b-col cols="7">
                            <vs-button style="border-radius: 5px; width: 100%" type="gradient" @click="faturaSec()"
                              icon="search" color="danger" disabled>Fatura Seç</vs-button>
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px">
                          <b-col cols="5" align-self="center">
                            <b-form-group label="Açıklama" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="7">
                            <vs-textarea label="(En fazla 500 karakter)" v-model="aciklama" v-on:keyup="countdown2"
                              maxlength="500" disabled />
                            <p class="text-right text-small" v-bind:class="{ 'text-danger': hasError2 }">
                              {{ remainingCount2 }}
                              <span v-if="hasError2" v-bind:class="{ 'text-danger': hasError2 }">
                                karakter sayısını aştınız</span>
                            </p>
                          </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 10px" v-if="itemDisabled == false">
                          <b-col cols="2" align-self="center">
                            <b-form-group label="Resim Ekle" label-for="h-first-name" style="font-size: 15px">
                            </b-form-group>
                          </b-col>
                          <b-col cols="5" align-self="center">
                            <input type="file" accept="image/*" @change="onFileChange" id="file-input" />
                          </b-col>
                          <b-col cols="5" align-self="center">
                            <vs-button color="primary" type="gradient" icon="done" style="border-radius: 5px"
                              @click="dosyaEkle()">Ekle</vs-button>
                          </b-col>
                        </b-row>
                        <b-row>
                          <div>
                            <b-badge style="float: left; width: 20%" :key="index" v-for="(item, index) in resimlerList">
                              <vs-card>
                                <b-row>
                                  <feather-icon icon="XIcon" class="cursor-pointer" svgClasses="w-8 h-8"
                                    style="color: red" @click="dosyaSil('warning', item)" />
                                </b-row>
                                <img style="width: 100%" v-bind:src="bindimage + item.URL" class="grid-view-img px-4"
                                  @click="resimBuyut(bindimage + item.URL)" />
                              </vs-card>
                            </b-badge>
                          </div>
                        </b-row>
                      </vs-card>
                    </b-col>
                  </b-row>
                </b-form>
              </span>
            </b-row>
          </div>

          <div>
            <p style="color: #fff">{{ SPECCODE1 }}</p>
            <vs-row v-if="itemDisabled == true" vs-justify="flex-end">
              <vs-button type="gradient" color="success" icon="save" style="border-radius: 5px" @click="yeniKayit()"
                id="button-with-loading-yeni" class="vs-con-loading__container">Kaydet</vs-button>
            </vs-row>

            <vs-row v-else vs-justify="flex-end">

              <vs-button v-if="SPECCODE1 == 'Kaydedildi' && onayMailButonValidate == true
              " style="border-radius: 5px" type="gradient" @click="adminMailOnayi()" icon="email" color="danger"
                id="button-with-loading-mail" class="vs-con-loading__container">Onaya Gönder</vs-button>

              <vs-button v-if="grupKodu == 'Admin' &&
                (SPECCODE1 == 'Onay Bekliyor' ||
                  SPECCODE1 == 'Kaydedildi') &&
                onayButonValidate == true
              " style="border-radius: 5px" type="gradient" @click="adminOnayi()" icon="done" color="#02a66d"
                gradient-color-secondary="rgb(1, 52, 74)">Onayla</vs-button>
              <vs-button v-if="SPECCODE1 != 'Onay Bekliyor' || SPECCODE1 != 'Kaydedildi'" type="gradient" icon="send"
                style="border-radius: 5px" @click="tedarikciMail()">Tedarikçiye Mail Gönder</vs-button>
              <vs-button v-if="(SPECCODE1 != 'Onay Bekliyor' || SPECCODE1 != 'Kaydedildi') &&
                onayButonValidate != true &&
                faturaKesildiValidate == false
              " type="gradient" icon="receipt" style="border-radius: 5px" @click="faturaKes()" color="danger">Fatura
                Kes</vs-button>

              <vs-button type="gradient" color="success" icon="add" style="border-radius: 5px"
                @click="hareketEkle()">Hareket
                Ekle</vs-button>
              <vs-button type="gradient" color="danger" icon="print" style="border-radius: 5px"
                @click="yazdir()">Yazdır</vs-button>
            </vs-row>
          </div>
        </vs-card>
      </b-col>
    </b-row>
    <!-- STOK BİLGİLERİ -->

    <b-row style="margin-bottom: 15px" v-if="itemDisabled == true">
      <b-col>
        <vx-card>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col>
                  <p style="text-align: center">Stok No</p>
                </b-col>
                <b-col>
                  <p style="text-align: center">Stok Adı</p>
                </b-col>

                <b-col cols="1">
                  <p style="text-align: center">Adet</p>
                </b-col>
                <b-col>
                  <p style="text-align: center">Fatura No</p>
                </b-col>
                <b-col>
                  <p style="text-align: center">Fatura Tarihi</p>
                </b-col>

                <b-col cols="1"> </b-col>
              </b-row>
            </b-col>

            <b-col cols="12">
              <b-row ref="row">
                <b-col align-self="center">
                  <v-select v-model="stokNo" label="STOCKNO" :options="rowData" @input="faturaStokKoduChange($event)">
                    <template slot="option" slot-scope="option">
                      {{ option.STOCKNO }} - {{ option.TRANSDATE }} -
                      {{ currencyFormatter(option.NETPRICE, "₺") }}
                    </template>
                  </v-select>
                </b-col>

                <b-col align-self="center">
                  <v-select v-model="stokAd" label="STOCKNAME" :options="rowData"
                    @input="faturaStokKoduChange($event)" />
                </b-col>

                <b-col cols="1" align-self="center" v-if="adetDisabledValidate == true">
                  <b-form-input id="faturaAdeti" placeholder="Adet" v-model="adet" disabled />
                </b-col>
                <b-col cols="1" align-self="center" v-else>
                  <b-form-input id="faturaAdeti" placeholder="Adet" v-model="adet" @input="adetKontrol()"
                    v-b-tooltip.hover.bottom="'Kalan adet' + kalanAdet" />
                </b-col>
                <b-col align-self="center">
                  <b-form-input id="faturaAdeti" placeholder="Fiş No" v-model="faturaNo" disabled />
                </b-col>
                <b-col align-self="center">
                  <b-form-input id="faturaAdeti" placeholder="Tarih" v-model="faturaTarih" disabled />
                </b-col>

                <b-col align-self="center" style="padding-right: 0" cols="1" class="mb-50">
                  <b-row style="padding: 0">
                    <b-col style="padding: 0">
                      <feather-icon icon="CheckIcon" class="cursor-pointer" svgClasses="w-7 h-7" style="color: green"
                        @click="addItem()" />
                    </b-col>
                  </b-row>
                </b-col>

                <!-- Remove Button -->

                <b-col cols="12" style="height: 5px"> </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- Row Loop -->
        </vx-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vs-card>
          <ag-grid-vue style="width: 100%" class="ag-theme-alpine" :defaultColDef="defaultColDef"
            :columnDefs="columnDefsSecilen" :rowData="rowDataSecilen" :localeText="localeText" :domLayout="domLayout"
            :rowSelection="rowSelection" :suppressCopyRowsToClipboard="true" @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered">
          </ag-grid-vue>
        </vs-card>
      </b-col>
    </b-row>
    <div style="display: none">
      <div id="printMeIade">
        <table border="1" style="width: 100%; border: none" class="border-collapse">
          <tr>
            <td>
              <table style="text-align: start; width: 100%">
                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    İşlem Türü
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ islemTuru.title }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    İade ve Arızalı Sebep
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ iadeSebep.title }}
                  </td>
                </tr>

                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    İade Şekli
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ iadeSekli.title }}
                  </td>
                </tr>
                <tr v-if="masrafValidate == 'true'">
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Masraf
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ masraf }}
                  </td>
                </tr>
                <tr v-if="raftaArizaliValidate == 'false'">
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Teslim Alan Personel
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ hareketACT }}
                  </td>
                </tr>

                <tr v-if="gondpersonelValidate == 'true'">
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Ürünü İsteyen Personel
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ gonderenpersonel }}
                  </td>
                </tr>
              </table>
            </td>

            <td>
              <table style="text-align: start; width: 100%">
                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Tedarikçi
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ query2 }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Cari Adı
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ query }}
                  </td>
                </tr>

                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Yıl
                  </td>

                  <td style="padding: 8px; border: 1px solid"></td>
                </tr>

                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Açıklama
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ aciklama }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <br />
        </table>

        <br />
        <hr />
        <table style="width: 100% !important; text-align: start" v-if="secilendegerDisabled == false">
          <tr>
            <th sort-key="stokkodu" style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              Resim
            </th>
            <th sort-key="stokkodu" style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              Fiş No
            </th>

            <th style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              Tarih
            </th>
            <th style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              Stok No
            </th>
            <th style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              Stok Adı
            </th>
            <th style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              Seçilen
            </th>
            <th style="
                text-align: start;
                border-bottom: 1px solid;

                padding: 3px;
              ">
              Net Fiyat
            </th>
          </tr>
          <tr :key="indextr" v-for="(tr, indextr) in rowDataSecilen">
            <td style="padding: 8px; border-right: 1px solid">
              <img :src="resimYazdir(tr.RESIM)" alt="" style="width: 80px" />
            </td>
            <td style="padding: 8px; border-right: 1px solid">
              {{ tr.RECEIPTNO }}
            </td>

            <td style="padding: 8px; border-right: 1px solid">
              {{ tr.FTARIH }}
            </td>
            <td style="padding: 8px; border-right: 1px solid">
              {{ tr.STOCKNO }}
            </td>
            <td style="padding: 8px; border-right: 1px solid">
              {{ tr.STOCKNAME }}
            </td>
            <td style="padding: 8px; border-right: 1px solid">
              {{ tr.SECILEN }}
            </td>
            <td style="padding: 8px; border-right: 1px solid">
              {{ tr.NETPRICE }}
            </td>
          </tr>
        </table>

        <br />
        <hr />
        <table style="width: 100% !important; text-align: start" v-if="secilendegerDisabled == false">
          <tr>
            <th sort-key="stokkodu" style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              Tarih
            </th>
            <th sort-key="stokkodu" style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              Açıklama
            </th>

            <th style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              İşlemi Yapan Personel
            </th>
            <th style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              Durum
            </th>
            <th style="
                text-align: start;
                border-bottom: 1px solid;
                border-right: 1px solid;
                padding: 3px;
              ">
              Tutar
            </th>
          </tr>

          <tr :key="indextr" v-for="(tr, indextr) in rowDataHareket">
            <td style="padding: 8px; border-right: 1px solid">
              {{ parseDate(tr.TARIH) }}
            </td>

            <td style="padding: 8px; border-right: 1px solid">
              {{ tr.ACIKLAMA }}
            </td>
            <td style="padding: 8px; border-right: 1px solid">
              {{ tr.PERSONEL }}
            </td>
            <td style="padding: 8px; border-right: 1px solid">
              {{ tr.DURUM }}
            </td>
            <td style="padding: 8px; border-right: 1px solid">
              {{ tr.TUTAR }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- HAREKETLER -->
    <b-row>
      <b-col>
        <vs-card>
          <vs-tabs alignment="fixed">
            <vs-tab label="Hareketler">
              <div>
                <ag-grid-vue style="width: 100%; height: 450px" class="ag-theme-alpine" :defaultColDef="defaultColDef"
                  :columnDefs="columnDefsHareket" :rowData="rowDataHareket" :localeText="localeText"
                  :suppressCopyRowsToClipboard="true" @first-data-rendered="onFirstDataRendered">
                </ag-grid-vue>
              </div>
            </vs-tab>
            <vs-tab label="Belgeler">
              <div>
                <b-badge style="float: left; width: 20%" :key="index" v-for="(item, index) in resimlerList">
                  <vs-card>
                    <b-row>
                      <feather-icon icon="XIcon" class="cursor-pointer" svgClasses="w-8 h-8" style="color: red"
                        @click="dosyaSil('warning', item)" />
                    </b-row>
                    <img style="width: 100%" v-bind:src="bindimage + item.URL" class="grid-view-img px-4"
                      @click="resimBuyut(bindimage + item.URL)" />
                  </vs-card>
                </b-badge>
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-card>
      </b-col>
    </b-row>
    <vs-popup type="filled" :active.sync="popupimageshow">
      <img v-bind:src="imageLink" style="width: 100%" /></vs-popup>
    <vs-popup type="filled" title="Fatura Yaz" :active.sync="popupFaturaYaz">
      <vx-card style="">
        <b-form @submit.prevent>
          <b-row style="margin-bottom: 10px">
            <b-col lg="12" sm="12">
              <vs-card>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="5" align-self="center">
                    <b-form-group label="İşlem Türü" label-for="h-first-name" style="font-size: 15px">
                    </b-form-group>
                  </b-col>

                  <b-col cols="7" align-self="center">
                    <div v-if="islemTuru.title == 'İade'">Satınalma İade</div>
                    <div v-else>Satınalma Arıza</div>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="5" align-self="center">
                    <b-form-group label="İade ve Arızalı Sebep" label-for="h-first-name" style="font-size: 15px">
                    </b-form-group>
                  </b-col>
                  <b-col cols="7">
                    <div v-if="islemTuru.title == 'İade'">Müşteriden İade</div>
                    <div v-else>Müşteriden Arızalı</div>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="5" align-self="center">
                    <b-form-group label="İade Şekli" label-for="h-first-name" style="font-size: 15px">
                    </b-form-group>
                  </b-col>

                  <b-col cols="7">
                    <v-select v-model="iadeSekliFatura" label="title" :options="optionIadeSekil2"
                      placeholder="İade Şekli" @input="iadesekFatura" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px" v-if="masrafValidate2 == 'true'">
                  <b-col cols="5" align-self="center">
                    <b-form-group label="Masraf" label-for="h-first-name" style="font-size: 15px">
                    </b-form-group>
                  </b-col>
                  <b-col cols="7">
                    <b-form-input id="masraf" placeholder="Masraf" v-model="masrafFatura" />
                  </b-col>
                </b-row>

                <b-row style="margin-bottom: 10px">
                  <b-col cols="5" align-self="center">
                    <b-form-group label="Açıklama" label-for="h-first-name" style="font-size: 15px">
                    </b-form-group>
                  </b-col>
                  <b-col cols="7">
                    <vs-textarea label="(En fazla 500 karakter)" v-model="aciklamaFatura" v-on:keyup="countdown3"
                      maxlength="500" />
                    <p class="text-right text-small" v-bind:class="{ 'text-danger': hasError3 }">
                      {{ remainingCount3 }}
                      <span v-if="hasError3" v-bind:class="{ 'text-danger': hasError3 }">
                        karakter sayısını aştınız</span>
                    </p>
                  </b-col>
                </b-row>
              </vs-card>
            </b-col>
          </b-row>
        </b-form>
        <b-row>
          <b-col>
            <vs-button class="float-right" color="primary" type="gradient" icon="done" style="border-radius: 5px"
              @click="faturaIslem()">Fatura Kes</vs-button>
          </b-col>
        </b-row>
      </vx-card>
    </vs-popup>
    <b-sidebar id="sidebar-right" bg-variant="white" right backdrop shadow>
    </b-sidebar>
    <vs-popup type="filled" title="Fatura Listesi" :active.sync="popupFaturaList" v-if="islemTuruKontrol == 'Arızalı Ürün' ||
      islemTuruKontrol == 'Rafta Arızalı'
    " fullscreen>
      <div id="invoice-page">
        <div class="items-center justify-between">
          <div class="items-center">
            <ag-grid-vue style="width: 100%; height: 550px" class="ag-theme-alpine" :defaultColDef="defaultColDef"
              :columnDefs="columnDefs" :rowData="rowData" :localeText="localeText" :pagination="true"
              :rowSelection="rowSelection" :suppressCopyRowsToClipboard="true" @grid-ready="onGridReady"
              @first-data-rendered="onFirstDataRendered" @selection-changed="onSelectionChanged">
            </ag-grid-vue>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup type="filled" title="Fatura Listesi" :active.sync="popupFaturaList" v-else fullscreen>
      <div id="invoice-page">
        <div class="items-center justify-between">
          <div class="items-center">
            <ag-grid-vue style="width: 100%; height: 550px" class="ag-theme-alpine" :defaultColDef="defaultColDef"
              :columnDefs="columnDefsMulti" :rowData="rowData" :localeText="localeText" :pagination="true"
              :rowSelection="rowSelectionMultiple" @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered"
              :rowMultiSelectWithClick="true" @selection-changed="secilenFaturaList"
              @cell-value-changed="onCellValueChanged" :suppressCopyRowsToClipboard="true">
            </ag-grid-vue>
          </div>
        </div>
      </div>
      <b-row>
        <b-col>
          <vs-button class="float-right" color="primary" type="gradient" icon="done" style="border-radius: 5px"
            @click="sepeteEkle()">Ekle</vs-button>
        </b-col>
      </b-row>
    </vs-popup>
    <b-modal ref="modal-primary" id="modal-primary" modal-class="modal-primary" centered size="xl"
      title="Fatura Listesi">
    </b-modal>
    <vs-popup type="filled" title="Hareket Ekle" :active.sync="popupHareketList">
      <div id="invoice-page" style="padding: 20px">
        <div class="items-center justify-between">
          <div class="items-center">
            <b-form @submit.prevent>
              <b-row style="margin-bottom: 10px">
                <b-col cols="3" align-self="center">
                  <b-form-group label="Durum" label-for="h-first-name" style="font-size: 15px">
                  </b-form-group>
                </b-col>
                <b-col cols="9">
                  <v-select v-model="stateVal" label="title" :options="state" placeholder="Durum" />
                </b-col>
              </b-row>
              <b-row style="margin-bottom: 10px">
                <b-col cols="3" align-self="center">
                  <b-form-group label="İşlem Tarihi" label-for="h-first-name" style="font-size: 15px">
                  </b-form-group>
                </b-col>
                <b-col cols="9">
                  <b-form-datepicker id="baslangic" v-model="hareketTarihi" size="md" local="en" class="mb-2"
                    today-variant="danger" placeholder="-" :start-weekday="weekday" :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric'
                    }" />
                </b-col>
              </b-row>
              <b-row style="margin-bottom: 10px">
                <b-col cols="3" align-self="center">
                  <b-form-group label="Personel" label-for="h-first-name" style="font-size: 15px">
                  </b-form-group>
                </b-col>
                <b-col cols="9">
                  <v-select v-model="hareketACT2" label="EMPLOYEENAME" :options="teslimAlanPersonel"
                    placeholder="İşlemi Yapan" />
                </b-col>
              </b-row>
              <b-row style="margin-bottom: 10px">
                <b-col cols="3" align-self="center">
                  <b-form-group label="Açıklama" label-for="h-first-name" style="font-size: 15px">
                  </b-form-group>
                </b-col>
                <b-col cols="9">
                  <vs-textarea label="Açıklama" v-model="hareketaciklama" />
                </b-col>
              </b-row>

              <b-row style="margin-bottom: 10px">
                <b-col cols="3" align-self="center">
                  <b-form-group label="Masraf Tutarı" label-for="h-first-name" style="font-size: 15px">
                  </b-form-group>
                </b-col>
                <b-col cols="9">
                  <b-form-input id="stok-no" v-model="masrafTutari" />
                </b-col>
              </b-row>
              <b-row>
                <b-col offset-md="8">
                  <vs-button color="primary" type="gradient" icon="done" style="border-radius: 5px"
                    @click="hareketKaydet()">Kaydet</vs-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup type="filled" pazaryer title="Tedarikçi Maili Gönder" :active.sync="popupTedarikciMail">
      <div>
        <b-row>
          <vs-card>
            <b-row style="margin-top: 25px; padding: 15px">
              <b-col lg="12">
                <b-row>
                  <b-col lg="8">
                    <vs-input style="
                        padding: 0.4rem !important;
                        margin-top: 0;
                        width: 100%;
                      " icon-after="true" icon="email" label-placeholder="E-Mail" v-model="girilenMail" /></b-col>

                  <b-col lg="2" align-self="center">
                    <vs-button @click="mailBtnGonder()" color="primary" icon="send" type="flat"
                      id="button-with-loading-mail" class="vs-con-loading__container"></vs-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row style="padding: 15px">
              <b-col lg="12">
                <vs-table :data="mailListesi" max-height="250px">
                  <template slot="thead">
                    <vs-th style="background-color: #e8e8fa" sort-key="EMAIL">E-Mail</vs-th>
                    <vs-th style="background-color: #e8e8fa" sort-key="YETKILI">Yetkili</vs-th>
                    <vs-th style="background-color: #e8e8fa" sort-key="MISSION">Görev</vs-th>
                    <vs-th style="background-color: #e8e8fa"></vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" s>
                      <vs-td style="font-size: small" :data="data[indextr].EMAIL">
                        {{ data[indextr].EMAIL }}
                      </vs-td>
                      <vs-td style="font-size: small" :data="data[indextr].YETKILI">
                        {{ data[indextr].YETKILI }}
                      </vs-td>
                      <vs-td style="font-size: small" :data="data[indextr].MISSION">
                        {{ data[indextr].MISSION }}
                      </vs-td>
                      <vs-td>
                        <vs-button @click="mailBtnGonder(data[indextr].EMAIL)" color="primary" icon="send"
                          type="flat"></vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </b-col>
            </b-row>
          </vs-card>
        </b-row>
      </div>
    </vs-popup>
    <IadeArizaOnayMail ref="iadeArizaMailRef" />
    <IadeArizaOnayMailForEmployee ref="iadeArizaOnayMailForEmployeeRef" />
    <IadeArizaTedarikciMail ref="iadeArizaTedarikciMailRef" />
    <IadeArizaMailDonusu ref="iadeArizaMailOnaylandiRef" />
  </div>
</template>
<script>
import { BButton, BSidebar } from "bootstrap-vue";
import moment from "moment";
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import vSelect from "vue-select";
import userJson from "../../../public/user.json";
import IadeArizaOnayMail from "../components/crm-components/satinalma-components/IadeArizaOnayMail.vue";
import IadeArizaOnayMailForEmployee from "../components/crm-components/satinalma-components/IadeArizaOnayMailForEmployee.vue"
import IadeArizaTedarikciMail from "../components/crm-components/satinalma-components/IadeArizaTedarikciMail.vue";
import IadeArizaDetayFaturaButton from "../components/crm-components/satinalma-components/IadeArizaDetayFaturaButton.vue";
import IadeArizaDetayFaturaSilButon from "../components/crm-components/satinalma-components/IadeArizaDetayFaturaSilButon.vue";
import IadeArizaDetaySepetResim from "../components/crm-components/satinalma-components/IadeArizaDetaySepetResim.vue";
import IadeArizaMailDonusu from "../components/crm-components/satinalma-components/IadeArizaMailDonusu.vue";
import iadeArizaStokAdiCellRenderer from "./CellRenderers/iadeArizaStokAdiCellRenderer.vue";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import user from "../../../public/user.json";
export default {
  data() {
    return {
      weekday: 1,
      hareketTarihi: "",
      stokNo: "",
      stokAd: "",
      adet: 0,
      faturaNo: "",
      faturaTarih: "",
      faturaId: "",
      fiyat: 0.0,
      currPrice: 0.0,
      itemNo: "",
      kalanAdet: 0,
      nextTodoId: 2,

      adetDisabledValidate: false,
      RECEIPTNO: "",

      faturaRECEIPTNO: "",
      faturaTRANSDATE: "",
      faturaAdeti: 0,
      faturaStokNo: "",
      faturaDeger: "",
      faturaList: [],
      imgSrcUrl: "https://servis.kamyonyedekparca.com",
      faturaKesildiValidate: false,
      masrafFatura: "",
      aciklamaFatura: "",
      iadeSekliFatura: null,
      activePrompt: false,
      popupFaturaList: false,
      TEDARIKCI: "",
      TEDARIKCIID: "",
      tedarikci: "",
      mailListesi: [],
      girilenMail: "",
      popupFaturaYaz: false,
      popupTedarikciMail: false,
      popupimageshow: false,
      imageLink: "",
      RECEIPTID: "",
      islemTuruKontrol: "",
      colorLoading: "#fff",
      kopyKontrolDisabled: false,
      hasError2: false,
      hasError3: false,
      maxCount: 500,
      remainingCount2: 500,
      remainingCount3: 500,
      resimGenel: "",
      grupKodu: "",
      SPECCODE1: "",
      silinecekResim: [],
      teslimAlanPersonel: "",
      bindimage: userJson.stockImage,
      resimlerList: [],
      domLayout: null,
      secilenFaturalar: [],
      dosyaF: "",
      dosyaFName: "",
      hareketACT: "",
      hareketACT2: "",
      rowDataHareket: [],
      columnDefsHareket: [],
      columnDefsMulti: [],
      popupHareketList: false,
      masrafTutari: 0.0,
      masrafValidate: false,
      gondpersonelValidate: false,
      hareketaciklama: "",
      columnDefsSecilen: [],
      rowDataSecilen: [],
      selectedRows: [],
      selectedResim: [],
      rowSelection: null,
      rowSelectionMultiple: null,
      rowData: [],
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      localeText: null,
      columnDefs: null,
      datasuggestpersonel: [],
      datasuggest2: [],
      querypersonel: "",
      query: "",
      query2: "",
      islemTuru: "",
      islemturuVal: "",
      yil: "",
      iadeSebep: "",
      iadeSekli: "",
      masraf: 0,
      aciklama: "",
      gonderenpersonel: "",
      teslimalan: "",
      ACTID: "",
      stateVal: "",
      onayMailButonValidate: false,
      onayButonValidate: false,
      filteredOptions: [],
      filteredOptions2: [],
      filteredOptionspersonel: [],
      sepetListesi: [],
      detay: [],
      secilendegerDisabled: false,
      itemDisabled: false,
      raftaArizaliValidate: "false",
      masrafValidate2: false,
      option: [
        { value: "69", title: "Arızalı Ürün" },
        { value: "12", title: "İade Ürün" },
        { value: "98", title: "Rafta Arızalı" },
        { value: "98", title: "Satın Alma İade" },
        { value: "99", title: "Fiyat Farkı" }
      ],
      optionYil: [
        { value: "1", title: "1 Yıl" },
        { value: "2", title: "2 Yıl" },
        { value: "3", title: "3 Yıl" },
        { value: "4", title: "4 Yıl" },
        { value: "5", title: "5 Yıl" }
      ],
      optionIade: [
        { value: "2", title: "Müşteri Yanlış İstemiş " },
        { value: "3", title: "Biz Yanlış Göndermişiz" },
        { value: "4", title: "Kullanılmadığından İade" }
      ],
      optionIade2: [{ value: "5", title: "Hiç Kullanılmadan Arızalı" }],
      optionIade3: [
        { value: "6", title: "Tedarikçi Yanlış Göndermiş" },
        { value: "7", title: "Biz Yanlış İstemişiz" },
        { value: "8", title: "Kullanılmadığından İade" }
      ],
      optionIade4: [{ value: "1", title: "Arızalı" }],
      optionIadeSekil: [
        { value: "1", title: "Müşteri Kendisi" },
        { value: "2", title: "Seyahatte Alndı" },
        { value: "3", title: "Kargo / Ambar" }
      ],
      optionIadeSekil2: [
        { value: "4", title: "Tedarikçi Kendisi Aldı" },
        { value: "5", title: "Seyahatte Bırakıldı" },
        { value: "3", title: "Kargo / Ambar" }
      ],
      state: [
        { title: "Onay Bekliyor" },
        { title: "Tamire Gönderildi" },
        { title: "Tamirden Geldi" },
        { title: "Üreticiye Mail Gönderildi" },
        { title: "Üreticiye Gönderildi" },
        { title: "Üreticiden Geldi" },
        { title: "Merkez Depoya Gönderildi" },
        { title: "Üreticiye Gönderilmeden Müşteriye İade" },
        { title: "Üreticiden Kabul Gördü" },
        { title: "Üretici Ret Etti" },
        { title: "İşlem Görmeden Müşteriye İade" },
        { title: "Üreticiden Kabul Gören Ürün Müşteriye Gönderildi" },
        { title: "Hurdaya Ayrıldı" },
        { title: "Pasif" },
        { title: "Müşteriden İade Faturası İstendi" },
        { title: "Müşteri İade Faturasını Kesti" }
      ]
    };
  },
  components: {
    TextGorunumCellRenderer,
    BButton,
    BSidebar,
    IadeArizaMailDonusu,
    iadeArizaStokAdiCellRenderer,
    IadeArizaTedarikciMail,
    IadeArizaDetaySepetResim,
    IadeArizaDetayFaturaSilButon,
    "v-select": vSelect,
    AgGridVue,
    IadeArizaDetayFaturaButton,
    IadeArizaOnayMail,
    IadeArizaOnayMailForEmployee
  },
  created() {
    const data = [];

    data["servisAdresi"] = localStorage.getItem("servisAdresi");
    data["id"] = localStorage.getItem("id");
    data["employeeid"] = localStorage.getItem("employeeid");
    data["firmaAdi"] = localStorage.getItem("firmaAdi");
    data["COMPANYNAME"] = user.userName;

    data["tokenId"] = localStorage.getItem("tokenId");

    data["COMPANYID"] = localStorage.getItem("COMPANYID");
    data["EMPLOYEENO"] = localStorage.getItem("EMPLOYEENO");
    data["EMAIL"] = localStorage.getItem("EMAIL");
    data["USERLONGNAME"] = localStorage.getItem("USERLONGNAME");
    var result = localStorage.getItem("tokenId").substring(1, 7);
    data["mailCode"] = result;
    data["loginpng"] = user.userLogo;
    data["GROUPCODE"] = localStorage.getItem("GROUPCODE");

    this.$store.commit("setToken", data);
    this.$store.commit(
      "account/IADEARIZA_DETAY",
      localStorage.getItem("IADEARIZA_DETAY_RECEIPTID")
    );

    this.domLayout = "autoHeight";
    var d = new Date();
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.getPersonelList();
    this.rowSelection = "single";
    this.rowSelectionMultiple = "multiple";

    if (typeof localStorage.getItem("IADEARIZA_DETAY_ISLEM") == "undefined") {
      this.itemDisabled = true;
      this.$store.commit("account/FATURASIL_BUTON_VALIDATE", this.itemDisabled);
    } else {
      let isssleeemm = {
        title: localStorage.getItem("IADEARIZA_DETAY_ISLEM"),
        value:
          localStorage.getItem("IADEARIZA_DETAY_ISLEM") == "Rafta Arızalı" ||
            localStorage.getItem("IADEARIZA_DETAY_ISLEM") == "Satın Alma İade"
            ? "98"
            : localStorage.getItem("IADEARIZA_DETAY_ISLEM") == "Fiyat Farkı"
              ? "99"
              : localStorage.getItem("IADEARIZA_DETAY_ISLEM") == "Arızalı" ||
                localStorage.getItem("IADEARIZA_DETAY_ISLEM") == "Arızalı Ürün"
                ? "69"
                : "12"
      };

      if (localStorage.getItem("IADEARIZA_DETAY_KONTOL") == "yeni") {
        this.itemDisabled = true;
        this.kopyKontrolDisabled = true;
        this.$store.commit(
          "account/FATURASIL_BUTON_VALIDATE",
          this.itemDisabled
        );
      } else {
        this.listeDetay(
          isssleeemm,
          localStorage.getItem("IADEARIZA_DETAY_RECEIPTID")
        );
        if (localStorage.getItem("IADEARIZA_DETAY_KONTOL") == "true") {
          this.itemDisabled = true;
          this.kopyKontrolDisabled = true;
          this.$store.commit(
            "account/FATURASIL_BUTON_VALIDATE",
            this.itemDisabled
          );
          this.sepetList();

        } else {
          this.hareketList();
          this.dosyaListesi();
          this.kalemListesi();
        }
      }
    }
    this.grupKodu = Store.state.GROUPCODE;
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("iadearizasepetList", () => {
      this.sepetList();
    });
  },
  beforeDestroy() {
    this.$root.$off("iadearizasepetList");
  },
  methods: {
    currencyFormatter(currency, sign) {
      var gelencurr = parseFloat(currency);
      var sansDec = gelencurr.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return sign + `${formatted}`;
    },
    adetKontrol() {
      const vs = this.$vs;
      if (parseInt(this.kalanAdet) < parseInt(this.adet)) {
        vs.notify({
          title: "Uyarı",
          text: "İade adet değeri Kalan adet değerinden büyük olamaz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
        this.adet = this.kalanAdet;
      }
    },

    addItem(index) {
      const vs = this.$vs;

      if (this.stokAd == "") {
        vs.notify({
          title: "Stok",
          text: "Stok değeri giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (this.adet <= 0) {
        vs.notify({
          title: "Stok",
          text: "Adet değeri giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        var vm = this;
        const vs = this.$vs;
        const soap = require("soap");
        const url = state.sistemAddress;
        var turofIslem = vm.islemTuru;

        if (typeof turofIslem == "object") {
          turofIslem = vm.islemTuru.title;
        }

        var args = {
          token: Store.state.tokenId,
          ISLEM: turofIslem,
          RECEIPTID: vm.faturaId,
          UserId: Store.state.UserId,
          STOCKID: vm.stokNo.STOCKID,
          ITEMNO: vm.itemNo,
          ADET: vm.adet,
          FIYAT: vm.fiyat,
          CURRPRICE: vm.currPrice
        };

        soap.createClient(url, function (err, client) {
          client.INT_IadeArizaliUrunSepetEkle(args, function (err, result) {
            if (result.INT_IadeArizaliUrunSepetEkleResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(
                result.INT_IadeArizaliUrunSepetEkleResult
              );
              vm.sepetList();
              vs.notify({
                title: "Sepet",
                text: "Ürün eklendi.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
              vm.stokNo = "";
              vm.stokAd = "";
              vm.adet = 0;
              vm.faturaNo = "";
              vm.faturaTarih = "";
              vm.faturaId = "";
              vm.fiyat = 0.0;
              vm.currPrice = 0.0;
              vm.itemNo = "";
              vm.kalanAdet = 0;
            } catch (error) {
              console.log(error);
              vs.notify({
                title: "Sepet",
                text: "Ürün eklenirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    faturaStokKoduChange(event) {
      this.stokAd = event;
      this.stokNo = event;
      this.faturaNo = event.RECEIPTNO;
      this.faturaTarih = event.TRANSDATE;
      this.fiyat = event.NETPRICE;
      this.currPrice = event.CURRPRICE;
      this.itemNo = event.ITEMNO;
      this.faturaId = event.RECEIPTID;
      this.kalanAdet = event.KALAN;
      if (this.islemTuru.title != "İade Ürün") {
        this.adet = 1;
      }
    },

    resimYazdir(url) {
      var changedPicture = url;
      if (url.toString().includes("~") == true) {
        changedPicture = url.toString().replace("~", "");
      }
      this.imgSrc = this.imgSrcUrl + changedPicture;
      return this.imgSrc;
    },
    iadesekFatura(event) {
      if (event.value == "3") this.masrafValidate2 = "true";
    },
    faturaIslem() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ISLEM: vm.islemTuru.title,
        RECEIPTID: vm.RECEIPTID,
        RECEIPTNO: vm.RECEIPTNO
      };

      soap.createClient(url, function (err, client) {
        client.INT_IadeArizaliFaturaYaz(args, function (err, result) {
          if (result.INT_IadeArizaliFaturaYazResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.INT_IadeArizaliFaturaYazResult);
            if (vm.veriler.response == "Ok") {
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              vs.notify({
                title: "Kayıt",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
              vm.hareketKaydet("Faturası Kesildi");
              vm.hareketList();
              vm.popupFaturaYaz = false;
              vm.masrafFatura = "";
              vm.aciklamaFatura = "";
            } else {
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              vs.notify({
                title: "Kayıt",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "Success",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            console.log(error);
          }
        });
      });
    },
    faturaKes() {
      this.popupFaturaYaz = true;
      //  this.$refs["sidebar-right"].show();
      //  this.$root.$emit("bv::toggle::collapse", "sidebar-right");
    },
    yazdir() {
      setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMeIade");
    },
    validateEmail(emailgelen) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailgelen)) {
        return true;
      } else {
        return false;
      }
    },
    mailBtnGonder(mail) {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {};
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-mail",
        scale: 0.45
      });

      if (vm.girilenMail != "") {
        if (vm.validateEmail(vm.girilenMail)) {
          args = {
            ALICI: vm.girilenMail + ", " + "muhasebe@canergroup.com.tr",
            MESAJ: vm.$refs.iadeArizaTedarikciMailRef.$el.innerHTML,
            KONU: "İade Arıza bilgilendirme"
          };
        } else {
          vs.loading.close("#button-with-loading-mail > .con-vs-loading");
          vs.notify({
            title: "Hata",
            text: "Mail adresinin doğru olduğundan emin olun.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center"
          });
        }
      } else if (vm.girilenMail == "") {
        if (mail != "" && typeof mail != "undefined") {
          args = {
            ALICI: mail + ", " + "muhasebe@canergroup.com.tr",
            MESAJ: vm.$refs.iadeArizaTedarikciMailRef.$el.innerHTML,
            KONU: "İade Arıza bilgilendirme"
          };
        } else {
          vs.loading.close("#button-with-loading-mail > .con-vs-loading");
          vs.notify({
            title: "Hata",
            text: "Mail adresi giriniz.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center"
          });
        }
      }

      soap.createClient(url, function (err, client) {
        client.mailGonder(args, function (err, result) {
          if (result.mailGonderResult == "-1") {
            Store.dispatch("logout");
            //vm.$store.dispatch('login', payload)
          }
          try {
            vm.hareketKaydet("Üreticiye Mail Gönderildi");
            vs.loading.close("#button-with-loading-mail > .con-vs-loading");
            vs.notify({
              title: "Mail",
              text: "Mail başarıyla gönderildi.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
          } catch (error) {
            vs.loading.close("#button-with-loading-mail > .con-vs-loading");
            vs.notify({
              title: "Mail",
              text: "Mail göndermede hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
      vm.girilenMail = "";
    },
    mailList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: vm.query2
      };
      soap.createClient(url, function (err, client) {
        client.INT_Ls_Act_ContactList(args, function (err, result) {
          if (result.INT_Ls_Act_ContactListResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_Ls_Act_ContactListResult);
          vm.mailListesi = vm.veriler;
        });
      });
    },
    tedarikciMail() {
      this.popupTedarikciMail = true;
      this.mailList();
    },
    resimBuyut(gelen) {
      this.imageLink = gelen;
      this.popupimageshow = true;
    },
    listeDetay(ISLEM, RECEIPTID) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (typeof RECEIPTID == "undefined") {
      } else {
        var turofIslem = ISLEM.title;
        vm.islemTuru = ISLEM;
        vm.RECEIPTID = RECEIPTID;
        var args = {
          token: Store.state.tokenId,
          ISLEM: turofIslem,
          RECEIPTID: RECEIPTID
        };
        soap.createClient(url, function (err, client) {
          client.INT_IadeArizaDetay(args, function (err, result) {
            if (result.INT_IadeArizaDetayResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vm.veriler = JSON.parse(result.INT_IadeArizaDetayResult);
              var list = JSON.parse(vm.veriler.jsonData);
              vm.query = list[0].ACTNAME;
              vm.ACTID = list[0].ACTID;
              vm.aciklama = list[0].DESCRIPTION1;
              vm.query2 = list[0].DELIVERYNAME;
              //    vm.fYil = list[0].FTARIH;
              vm.iadeSebep = {
                title: list[0].DESCRIPTION,
                value:
                  list[0].DESCRIPTION == "Arızalı"
                    ? "1"
                    : list[0].DESCRIPTION == "Müşteri Yanlış İstemiş"
                      ? "2"
                      : list[0].DESCRIPTION == "Biz Yanlış Göndermişiz"
                        ? "3"
                        : list[0].DESCRIPTION == "Kullanılmadığından İade"
                          ? "4"
                          : list[0].DESCRIPTION == "Hiç Kullanılmadan Arızalı"
                            ? "5"
                            : list[0].DESCRIPTION == "Tedarikçi Yanlış Göndermiş"
                              ? "6"
                              : list[0].DESCRIPTION == "Biz Yanlış İstemişiz"
                                ? "7"
                                : "8"
              };

              vm.iadeSekli = {
                value: list[0].SPECCODE2,
                title:
                  list[0].SPECCODE2 == "1"
                    ? "Müşteri Kendisi"
                    : list[0].SPECCODE2 == "2"
                      ? "Seyahatte Alndı"
                      : list[0].SPECCODE2 == "3"
                        ? "Kargo / Ambar"
                        : list[0].SPECCODE2 == "4"
                          ? "Tedarikçi Kendisi Aldı"
                          : "Seyahatte Bırakıldı"
              };

              vm.gonderenpersonel = list[0].DESCRIPTION2;
              if (vm.iadeSebep.value == "3") vm.gondpersonelValidate = "true";

              vm.SPECCODE1 = list[0].SPECCODE1;
              if (
                vm.SPECCODE1 == "Kaydedildi" ||
                vm.SPECCODE1 == "Onay Bekliyor"
              ) {
                vm.itemDisabled = false;
                vm.$store.commit(
                  "account/FATURASIL_BUTON_VALIDATE",
                  vm.itemDisabled
                );
                vm.onayMailButonValidate = true;
                vm.onayButonValidate = true;
              }
              if (vm.SPECCODE1 == "Faturası Kesildi") {
                vm.faturaKesildiValidate = true;
              }
              vm.hareketACT = list[0].NAME2;
              vm.$refs.iadeArizaMailRef.getItems(list, turofIslem);
              vm.$refs.iadeArizaOnayMailForEmployeeRef.getItems(list, turofIslem)
              vm.$refs.iadeArizaTedarikciMailRef.getItems(list, turofIslem);
              vm.$store.commit("account/ONAY_MAIL_MUSTERI", list[0].ACTNAME);
              vm.$store.commit("account/ONAY_MAIL_FISNO", vm.RECEIPTID);
              vm.$store.commit("account/ONAY_MAIL_ISLEM", turofIslem);

              //  vm.masraf = list[0].MASRAF;
              if (list[0].ISLEM == "Rafta Arızalı") {
                vm.islemturuVal = "201";
              } else vm.islemturuVal = "101";
            } catch (error) {
              console.log(error);
            }
          });
        });
      }
    },
    countdown2() {
      this.remainingCount2 = this.maxCount - this.aciklama.length;
      this.hasError2 = this.remainingCount2 < 0;
    },
    countdown3() {
      this.remainingCount3 = this.maxCount - this.aciklamaFatura.length;
      this.hasError3 = this.remainingCount3 < 0;
    },
    kalemListesi() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (typeof vm.RECEIPTID == "undefined") {
      } else {
        var turofIslem = vm.islemTuru;
        if (typeof turofIslem == "object") {
          turofIslem = vm.islemTuru.title;
        }
        var args = {
          token: Store.state.tokenId,
          ISLEM: turofIslem,
          RECEIPTID: vm.RECEIPTID
        };
        soap.createClient(url, function (err, client) {
          client.INT_IadeArizaliUrunKalemListesi(args, function (err, result) {
            if (result.INT_IadeArizaliUrunKalemListesiResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vm.veriler = JSON.parse(
                result.INT_IadeArizaliUrunKalemListesiResult
              );
              if (vm.veriler.length == 0) {
                vm.secilendegerDisabled = true;
              } else {
                vm.secilendegerDisabled = false;
              }
              vm.rowDataSecilen = vm.veriler;
              vm.RECEIPTNO = vm.rowDataSecilen[0].RECEIPTNO;
              vm.$store.commit("account/IADEARIZA_KALEM_LIST", vm.rowDataSecilen);
              vm.$store.commit("account/IADEARIZA_KALEM_LIST", vm.rowDataSecilen);
            } catch (error) { }
          });
        });
      }
    },

    adminMailOnayi() {
      var vm = this;

      const vs = this.$vs;
      /*  vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-mail",
        scale: 0.45,
      });*/
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        ALICI: "volkancaner@canergroup.com.tr",
        MESAJ: this.$refs.iadeArizaMailRef.$el.innerHTML,
        KONU: "İade Arıza Onay İşlemi"
      };

      soap.createClient(url, function (err, client) {
        client.mailGonder(args, function (err, result) {
          if (result.mailGonderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.onayMailButonValidate = false;
            vs.notify({
              title: "Mail",
              text: "Mail başarıyla gönderildi.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
            vm.infoMail();
            vm.hareketKaydet("Onay Bekliyor");
          } catch (error) {
            console.log(error);
            vs.loading.close("#button-with-loading-mail > .con-vs-loading");
            vs.notify({
              title: "Mail",
              text: "Mail göndermede hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    infoMail() {
      var vm = this;

      const vs = this.$vs;
      /*  vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-mail",
        scale: 0.45,
      });*/
      const soap = require("soap");
      const url = state.sistemAddress; 
      const args = {
        ALICI: "muhasebe@canergroup.com.tr, satinalma@canergroup.com.tr, satis@canergroup.com.tr",
        MESAJ: this.$refs.iadeArizaOnayMailForEmployeeRef.$el.innerHTML,
        KONU: "İade Arıza Bilgilendirme İşlemi"
      };

      soap.createClient(url, function (err, client) {
        client.mailGonder(args, function (err, result) {
          if (result.mailGonderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.onayMailButonValidate = false;
            vs.notify({
              title: "Mail",
              text: "Mail başarıyla gönderildi.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            }); 
          } catch (error) {
            console.log(error);
            vs.loading.close("#button-with-loading-mail > .con-vs-loading");
            vs.notify({
              title: "Mail",
              text: "Mail göndermede hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    adminOnayi() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      var args = {
        token: Store.state.tokenId,
        ISLEM: vm.islemTuru.title,
        RECEIPTID: vm.RECEIPTID,
        ONAY: "Onayla",
        ONAYLAYAN: Store.state.USERLONGNAME
      };
      soap.createClient(url, function (err, client) {
        client.INT_IadeArizaliUrunOnay(args, function (err, result) {
          if (result.INT_IadeArizaliUrunOnayResult == "-1") {
            Store.dispatch("logout");
          }
          if (result.INT_IadeArizaliUrunOnayResult == "Onay İşlemi Tamam") {
            vs.notify({
              title: "Başarılı",
              text: "Onay işlemi tamam",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
            vm.hareketList();
            vm.mailBtnOnayGonder();
            vm.onayButonValidate = false;
            vm.onayMailButonValidate = false;
          }
        });
      });
    },
    mailBtnOnayGonder() {
      const vs = this.$vs;
      const soap = require("soap");
      const url = userJson.userService;
      var args = {};

      if (this.gelenMail != "" && typeof this.gelenMail != "undefined") {
        args = {
          ALICI: this.gelenMail,
          MESAJ: this.$refs.iadeArizaMailOnaylandiRef.$el.innerHTML,
          KONU: "İade Arıza bilgilendirme"
        };
      } else {
        vs.loading.close("#button-with-loading-mail > .con-vs-loading");
        vs.notify({
          title: "Hata",
          text: "Mail adresi giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center"
        });
      }

      soap.createClient(url, function (err, client) {
        client.mailGonder(args, function (err, result) {
          var vm = this;
          if (result.mailGonderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.mailGonderResultResult);
            if (vm.veriler.response == "Ok") {
              vs.loading.close("#button-with-loading-mail > .con-vs-loading");
              vs.notify({
                title: "Mail",
                text: "Mail başarıyla gönderildi." + vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-mail > .con-vs-loading");
            vs.notify({
              title: "Mail",
              text: "Mail göndermede hata oluştu." + vm.veriler.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    dosyaSil(color, item) {
      this.silinecekResim = item;
      this.$vs.dialog({
        color: color,
        title: "Uyarı", //`Dialog - ${this.colorAlert}`,
        text: "Resim Silinecek Emin misiniz ?",
        acceptText: "Sil",
        accept: this.dosyaResimSil
      });
    },
    dosyaResimSil() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      var args = {
        token: Store.state.tokenId,
        ISLEM: vm.islemTuru.title,
        RECEIPTID: vm.RECEIPTID,
        ITEMNO: vm.silinecekResim.ITEMNO
      };
      soap.createClient(url, function (err, client) {
        client.INT_IadeArizaliUrunDosyaSil(args, function (err, result) {
          if (result.INT_IadeArizaliUrunDosyaSilResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.INT_IadeArizaliUrunDosyaSilResult);
            vm.dosyaListesi();
          } catch (error) { }
        });
      });
    },
    iadeValidate() {
      if (this.iadeSekli.value == "3") {
        this.masrafValidate = "true";
      } else {
        this.masrafValidate = false;
      }
      //  masrafValidate
    },

    onCellValueChanged(params) {
      try {
        const rowNode = this.gridApi.getDisplayedRowAtIndex(params.rowIndex);
        const colId = params.column.getId();
        if (colId === "IADEADET") {
          if (params.newValue > params.data.KALAN) {
            const vs = this.$vs;
            vs.notify({
              title: "Uyarı",
              text: "İade adet değeri Kalan adet değerinden büyük olamaz",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center"
            });
            params.data.IADEADET = 0;
            rowNode.setDataValue("IADEADET", 0);
          } else {
            params.data.IADEADET = params.newValue;
          }
        }
      } catch (error) {
        // console.log(error);
      }
    },
    secilenFaturaList() {
      var selectedRows = this.gridApi.getSelectedRows();
      this.secilenFaturalar = selectedRows;
    },
    sepetList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var turofIslem = vm.islemTuru;
      if (typeof turofIslem == "object") {
        turofIslem = vm.islemTuru.title;
      }

      var args = {
        token: Store.state.tokenId,
        ISLEM: turofIslem,
        UserId: Store.state.UserId
      };
      soap.createClient(url, function (err, client) {
        client.INT_IadeArizaliUrunSepetListesi(args, function (err, result) {
          if (result.INT_IadeArizaliUrunSepetListesiResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(
              result.INT_IadeArizaliUrunSepetListesiResult
            );
            vm.rowDataSecilen = vm.veriler;
            if (vm.veriler.length == 0) {
              vm.secilendegerDisabled = true;
            } else {
              vm.secilendegerDisabled = false;
            }
          } catch (error) { }
        });
      });
    },

    yeniKayit() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const today = new Date();
      var turofIslem = vm.islemTuru;

      var iadesebebi = vm.iadeSebep.title;
      var iadesekil = vm.iadeSekli.value;
      var teslimaa = vm.hareketACT.EMPLOYEENAME;
      if (typeof turofIslem == "object") {
        turofIslem = vm.islemTuru.title;
      }
      if (typeof iadesebebi == "undefined") {
        iadesebebi = "";
      }
      if (typeof iadesekil == "undefined") {
        iadesekil = "";
      }
      if (typeof teslimaa == "undefined") {
        teslimaa = "";
      }
      vs.loading({
        background: "#0064fa",
        color: this.colorLoading,
        container: "#button-with-loading-yeni",
        scale: 0.45
      });
      if (turofIslem == "") {
        setTimeout(() => {
          vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
        }, 1000);
        vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
        vs.notify({
          title: "Kayıt",
          text: "İşlem değeri gerekli",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center"
        });
      } else {
        if (teslimaa == "" || vm.TEDARIKCI == "") {
          if (turofIslem == "Arızalı Ürün") {
            setTimeout(() => {
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }, 1000);

            vs.notify({
              title: "Kayıt",
              text: "Teslim alan ve Tedarikçi adı değeri boş olamaz",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          } else {
            var args = {
              token: Store.state.tokenId,
              ISLEM: turofIslem,
              RECEIPTID: "",
              TARIH: moment(String(today)).format("DD.MM.YYYY"),
              SEVKTARIHI: moment(String(today)).format("DD.MM.YYYY"),
              SEBEP: iadesebebi,
              MASRAF: vm.masraf,
              EMPLOYEEID: Store.state.employeeid,
              USERNAME: Store.state.USERLONGNAME,
              GONDEREN: vm.gonderenpersonel.EMPLOYEENAME,
              IADESEKLI: iadesekil,
              TESLIMALAN: teslimaa,
              ACIKLAMAG: vm.aciklama,
              UserId: Store.state.UserId,
              RECEIPTTYPE2: vm.islemTuru.value,
              TEDARIKCI: vm.TEDARIKCIID,
              TEDARIKCINAME: vm.TEDARIKCI,
              USR_ACIK: vm.RECEIPTID + "-" + vm.query
            };
            if (vm.islemTuru.value == "98") {
              var args = {
                token: Store.state.tokenId,
                ISLEM: turofIslem,
                RECEIPTID: "",
                TARIH: moment(String(today)).format("DD.MM.YYYY"),
                SEVKTARIHI: moment(String(today)).format("DD.MM.YYYY"),
                SEBEP: vm.aciklama,
                MASRAF: vm.masraf,
                EMPLOYEEID: Store.state.employeeid,
                USERNAME: Store.state.USERLONGNAME,
                GONDEREN: vm.gonderenpersonel.EMPLOYEENAME,
                IADESEKLI: iadesekil,
                TESLIMALAN: teslimaa,
                ACIKLAMAG: iadesebebi,
                UserId: Store.state.UserId,
                RECEIPTTYPE2: vm.islemTuru.value,
                TEDARIKCI: vm.TEDARIKCIID,
                TEDARIKCINAME: vm.TEDARIKCI,
                USR_ACIK: vm.RECEIPTID + "-" + vm.query
              };
            }
            soap.createClient(url, function (err, client) {
              client.INT_IadeArizaliUrunBaslik(args, function (err, result) {
                if (result.INT_IadeArizaliUrunBaslikResult == "-1") {
                  Store.dispatch("logout");
                }
                try {
                  vm.veriler = JSON.parse(
                    result.INT_IadeArizaliUrunBaslikResult
                  );
                  if (vm.veriler.response == "Ok") {
                    vs.loading.close(
                      "#button-with-loading-yeni > .con-vs-loading"
                    );
                    vs.notify({
                      title: "Kayıt",
                      text: vm.veriler.message,
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "success",
                      position: "top-center"
                    });
                    vm.RECEIPTID = vm.veriler.jsonData;
                    vm.listeDetay(vm.islemTuru, vm.RECEIPTID);
                    vm.sepetList();
                    vm.dosyaListesi();
                    vm.kalemListesi();
                    vm.hareketList();
                  } else {
                    vs.loading.close(
                      "#button-with-loading-yeni > .con-vs-loading"
                    );
                    vs.notify({
                      title: "Kayıt",
                      text: vm.veriler.message,
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "Success",
                      position: "top-center"
                    });
                  }
                } catch (error) {
                  vs.loading.close(
                    "#button-with-loading-yeni > .con-vs-loading"
                  );
                  console.log(error);
                }
              });
            });
          }
        } else {
          var args = {
            token: Store.state.tokenId,
            ISLEM: turofIslem,
            RECEIPTID: "",
            TARIH: moment(String(today)).format("DD.MM.YYYY"),
            SEVKTARIHI: moment(String(today)).format("DD.MM.YYYY"),
            SEBEP: iadesebebi,
            MASRAF: vm.masraf,
            EMPLOYEEID: Store.state.employeeid,
            USERNAME: Store.state.USERLONGNAME,
            GONDEREN: vm.gonderenpersonel.EMPLOYEENAME,
            IADESEKLI: iadesekil,
            TESLIMALAN: teslimaa,
            ACIKLAMAG: vm.aciklama,
            UserId: Store.state.UserId,
            RECEIPTTYPE2: vm.islemTuru.value,
            TEDARIKCI: vm.TEDARIKCIID,
            TEDARIKCINAME: vm.TEDARIKCI
          };
          if (vm.islemTuru.value == "98") {
            var args = {
              token: Store.state.tokenId,
              ISLEM: turofIslem,
              RECEIPTID: "",
              TARIH: moment(String(today)).format("DD.MM.YYYY"),
              SEVKTARIHI: moment(String(today)).format("DD.MM.YYYY"),
              SEBEP: vm.aciklama,
              MASRAF: vm.masraf,
              EMPLOYEEID: Store.state.employeeid,
              USERNAME: Store.state.USERLONGNAME,
              GONDEREN: vm.gonderenpersonel.EMPLOYEENAME,
              IADESEKLI: iadesekil,
              TESLIMALAN: teslimaa,
              ACIKLAMAG: iadesebebi,
              UserId: Store.state.UserId,
              RECEIPTTYPE2: vm.islemTuru.value,
              TEDARIKCI: vm.TEDARIKCIID,
              TEDARIKCINAME: vm.TEDARIKCI
            };
          }
          soap.createClient(url, function (err, client) {
            client.INT_IadeArizaliUrunBaslik(args, function (err, result) {
              if (result.INT_IadeArizaliUrunBaslikResult == "-1") {
                Store.dispatch("logout");
              }
              try {
                vm.veriler = JSON.parse(result.INT_IadeArizaliUrunBaslikResult);
                if (vm.veriler.response == "Ok") {
                  vs.loading.close(
                    "#button-with-loading-yeni > .con-vs-loading"
                  );
                  vs.notify({
                    title: "Kayıt",
                    text: vm.veriler.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center"
                  });
                  vm.RECEIPTID = vm.veriler.jsonData;
                  vm.listeDetay(vm.islemTuru, vm.RECEIPTID);
                  vm.sepetList();
                  vm.dosyaListesi();
                  vm.kalemListesi();
                  vm.hareketList();
                } else {
                  vs.loading.close(
                    "#button-with-loading-yeni > .con-vs-loading"
                  );
                  vs.notify({
                    title: "Kayıt",
                    text: vm.veriler.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "Success",
                    position: "top-center"
                  });
                }
              } catch (error) {
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
                console.log(error);
              }
            });
          });
        }
      }
    },
    selectedOption(event) {
      //  this.islemTuru = event.title;
      this.islemTuruKontrol = event.title;
      this.getArizaliUrunList();

      if (this.islemTuru.title != "İade Ürün") {
        this.adetDisabledValidate = true;
      } else {
        this.adetDisabledValidate = false;
      }

      if (
        (event.title == "İade Ürün" && this.iadeSebep.value == "3") ||
        (event.title == "Satın Alma İade" && this.iadeSebep.value == "7")
      )
        this.gondpersonelValidate = "true";
      else if (
        event.title == "Rafta Arızalı" ||
        event.title == "Satın Alma İade"
      )
        this.raftaArizaliValidate = "true";
      else {
        this.raftaArizaliValidate = "false";
        this.gondpersonelValidate = false;
      }
      this.sepetList();
    },
    dosyaListesi() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (typeof vm.RECEIPTID == "undefined") {
      } else {
        var args = {
          token: Store.state.tokenId,
          ISLEM: vm.islemTuru.title,
          RECEIPTID: vm.RECEIPTID
        };
        soap.createClient(url, function (err, client) {
          client.INT_IadeArizaliUrunEkler(args, function (err, result) {
            if (result.INT_IadeArizaliUrunEklerResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vm.veriler = JSON.parse(result.INT_IadeArizaliUrunEklerResult);
              vm.resimlerList = vm.veriler;
              vm.$refs.iadeArizaTedarikciMailRef.dosyaListesi(
                vm.islemTuru.title,
                vm.RECEIPTID
              );
            } catch (error) { }
          });
        });
      }
    },
    upload(f, fileName) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      var letters = {
        İ: "I",
        I: "I",
        Ş: "S",
        Ğ: "G",
        Ü: "U",
        Ö: "O",
        Ç: "C",
        ı: "i",
        ş: "s",
        ğ: "g",
        ü: "u",
        ö: "o",
        ç: "c"
      };
      const args = {
        f: vm.dosyaF,
        stokKodu: this.pictureBarcode, // this.pictureBarcode,
        barkod: "",
        fileName: vm.dosyaFName.replace(/(([İIŞĞÜÇÖışğüöç]))/g, function (
          letter
        ) {
          return letters[letter];
        })
      };
      soap.createClient(url, function (err, client) {
        client.uploadFileProduct(args, function (err, result) {
          vm.dosyaListesi();
        });
      });
    },
    dosyaEkle() {
      var vm = this;
      const vs = this.$vs;
      vm.upload();
      const soap = require("soap");
      const url = state.sistemAddress;

      var turofIslem = vm.islemTuru;
      if (typeof turofIslem == "object") {
        turofIslem = vm.islemTuru.title;
      }
      var letters = {
        İ: "I",
        I: "I",
        Ş: "S",
        Ğ: "G",
        Ü: "U",
        Ö: "O",
        Ç: "C",
        ı: "i",
        ş: "s",
        ğ: "g",
        ü: "u",
        ö: "o",
        ç: "c"
      };

      var args = {
        token: Store.state.tokenId,
        ISLEM: turofIslem,
        RECEIPTID: vm.RECEIPTID,
        FILENAME: vm.dosyaFName.replace(/(([İIŞĞÜÇÖışğüöç]))/g, function (
          letter
        ) {
          return letters[letter];
        })
      };

      soap.createClient(url, function (err, client) {
        client.INT_IadeArizaliUrunDosyaEkle(args, function (err, result) {
          if (result.INT_IadeArizaliUrunDosyaEkleResult == "-1") {
            Store.dispatch("logout");
          }

          try {
            vm.veriler = JSON.parse(result.INT_IadeArizaliUrunDosyaEkleResult);
            if (vm.veriler.response == "Ok") {
              vs.notify({
                title: "Dosya",
                text: "Resim başarıyla eklendi.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
              //  vm.dosyaFName = "";
              vm.dosyaListesi();
            } else {
              vs.notify({
                title: "Dosya",
                text: "Resim eklemede hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          } catch (error) { }
        });
      });
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    hareketKaydet(gelen) {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      var harekett = vm.hareketACT2;

      if (typeof vm.hareketACT2 == "object") {
        harekett = vm.hareketACT2.EMPLOYEENAME;
      }
      var turofIslem = vm.islemTuru;
      if (typeof turofIslem == "object") {
        turofIslem = vm.islemTuru.title;
      }
      var turofDurum = vm.stateVal;
      if (typeof turofDurum == "object") {
        turofDurum = vm.stateVal.title;
      }
      if (harekett == "") harekett = Store.state.firmaAdi;
      if (turofDurum == "") {
        turofDurum = gelen;
        vm.hareketaciklama = gelen;
      }
      var args = {
        token: Store.state.tokenId,
        ISLEM: turofIslem,
        RECEIPTID: vm.RECEIPTID,
        ACIKLAMA: vm.hareketaciklama,
        PERSONEL: harekett,
        MASRAF: vm.masrafTutari,
        DURUM: turofDurum,
        TARIH: vm.hareketTarihi
      };

      soap.createClient(url, function (err, client) {
        client.INT_IadeArizaliUrunHareketEkle(args, function (err, result) {
          if (result.INT_IadeArizaliUrunHareketEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(
              result.INT_IadeArizaliUrunHareketEkleResult
            );
            if (vm.veriler.response == "Ok") {
              vm.popupHareketList = false;
              vm.stateVal = "";
              vm.hareketaciklama = "";
              vm.hareketACT2 = "";
              vm.masrafTutari = "";
              vm.hareketTarihi = "";
              vm.hareketList();

              let deger = { title: turofIslem };
              vm.listeDetay(deger, vm.RECEIPTID);

              vs.notify({
                title: "Hareket Ekle",
                text: "Hareket Ekleme İşlemi Başarılı.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center"
              });
            } else {
              vs.notify({
                title: "Hareket Ekle",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          } catch (error) {
            console.log(error);
            vs.notify({
              title: "Hareket Ekle",
              text: "Hata vaaarrr",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    sifirla(event) {
      if (
        (this.islemTuru.title == "İade Ürün" && event.value == "3") ||
        (this.islemTuru.title == "Satın Alma İade" && event.value == "7")
      ) {
        this.gondpersonelValidate = "true";
      } else this.gondpersonelValidate = false;
    },
    hareketEkle() {
      this.popupHareketList = true;
    },
    sepeteEkle() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      var turofIslem = vm.islemTuru;
      if (typeof turofIslem == "object") {
        turofIslem = vm.islemTuru.title;
      }
      vm.rowData.forEach((val, i) => {
        if (typeof val.IADEADET != "undefined") {
          var args = {
            token: Store.state.tokenId,
            ISLEM: turofIslem,
            RECEIPTID: val.RECEIPTID,
            UserId: Store.state.UserId,
            STOCKID: val.STOCKID,
            ITEMNO: val.ITEMNO,
            ADET: val.IADEADET,
            FIYAT: val.NETPRICE,
            CURRPRICE: val.CURRPRICE

          };
          // console.log(args)
          soap.createClient(url, function (err, client) {
            client.INT_IadeArizaliUrunSepetEkle(args, function (err, result) {
              if (result.INT_IadeArizaliUrunSepetEkleResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              try {
                vm.veriler = JSON.parse(
                  result.INT_IadeArizaliUrunSepetEkleResult
                );
                vm.sepetList();
              } catch (error) {
                vs.notify({
                  title: "Sepet",
                  text: "Ürün eklenirken hata oluştu.",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
              }
            });
          });
        }
      });
      this.popupFaturaList = false;
    },
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
      this.popupFaturaList = false;
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      var turofIslem = vm.islemTuru;
      if (typeof turofIslem == "object") {
        turofIslem = vm.islemTuru.title;
      }

      var args = {
        token: Store.state.tokenId,
        ISLEM: turofIslem,
        RECEIPTID: this.selectedRows[0].RECEIPTID,
        UserId: Store.state.UserId,
        STOCKID: this.selectedRows[0].STOCKID,
        ITEMNO: this.selectedRows[0].ITEMNO,
        ADET: "1",
        FIYAT: this.selectedRows[0].NETPRICE,
        CURRPRICE: this.selectedRows[0].CURRPRICE


      };
      //  console.log(args)
      soap.createClient(url, function (err, client) {
        client.INT_IadeArizaliUrunSepetEkle(args, function (err, result) {
          if (result.INT_IadeArizaliUrunSepetEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_IadeArizaliUrunSepetEkleResult);
            vm.sepetList();
          } catch (error) {
            vs.notify({
              title: "Sepet",
              text: "Ürün eklenirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.autoSizeAll();
    },
    faturaSec() {
      this.popupFaturaList = true;
      this.getArizaliUrunList();
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = e => {
        vm.image = e.target.result;

        // vm.upload(e.target.result, file.name);
        vm.dosyaF = e.target.result;
        vm.dosyaFName = file.name;
      };
      reader.readAsDataURL(file);
    },

    onInputChange2(text) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ARANAN: text
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_Act_ActSec(args, function (err, result) {
          if (result.INT_Ls_Act_ActSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_Act_ActSecResult);
          vm.datasuggest = vm.veriler;

          if (text === "" || text === undefined) {
            vm.isDisabled = true;
            return;
          }
          vm.filteredOptions2 = [
            {
              data: vm.datasuggest.filter(option => {
                return (
                  option.ACTNAME.toLowerCase().indexOf(
                    vm.query2.toLowerCase()
                  ) > -1
                );
              })
            }
          ];
        });
      });
    },

    onInputChange(text) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ARANAN: text
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_Act_ActSec(args, function (err, result) {
          if (result.INT_Ls_Act_ActSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_Act_ActSecResult);
          vm.datasuggest = vm.veriler;

          if (text === "" || text === undefined) {
            vm.isDisabled = true;
            return;
          }
          vm.filteredOptions = [
            {
              data: vm.datasuggest.filter(option => {
                return (
                  option.ACTNAME.toLowerCase().indexOf(vm.query.toLowerCase()) >
                  -1
                );
              })
            }
          ];
          // console.log(vm.filteredOptions)

        });
      });
    },
    getSuggestionValue2(suggestion) {
      this.TEDARIKCI = suggestion.item.ACTNAME;
      this.TEDARIKCIID = suggestion.item.ACTID;
      this.getArizaliUrunList();
      //    this.setData(this.ACTNAME);
      //    this.$store.commit("account/SATINALMA_ACTID", this.ACTID);

      //this.params.api.stopEditing();

      // if(suggestion)
      //   this.isDisabled = false;
      return suggestion.item.ACTNAME;
    },
    getSuggestionValue(suggestion) {
      this.ACTNAME = suggestion.item.ACTNAME;
      this.ACTID = suggestion.item.ACTID;
      this.getArizaliUrunList();
      //    this.setData(this.ACTNAME);
      //    this.$store.commit("account/SATINALMA_ACTID", this.ACTID);

      //this.params.api.stopEditing();

      // if(suggestion)
      //   this.isDisabled = false;
      return suggestion.item.ACTNAME;
    },
    onInputChangepersonel() {
      var vm = this;
      vm.filteredOptionspersonel = [
        {
          data: vm.datasuggestpersonel.filter(option => {
            return (
              option.EMPLOYEENAME.toLowerCase().indexOf(
                vm.querypersonel.toLowerCase()
              ) > -1
            );
          })
        }
      ];
    },

    getLastMonth(yil) {
      var d = new Date();
      d.setFullYear(d.getFullYear() - yil);
      return moment(String(d)).format("MM.DD.yyyy");
      // d.toLocaleDateString();
    },
    getArizaliUrunList() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      if (vm.ACTID == "" && vm.islemTuru.value != "98") {
        vs.notify({
          title: "İade ve Arızalı Ürün",
          text: "Cari değerleri eksik.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.islemTuru == "" && vm.islemturuVal == "") {
        vs.notify({
          title: "İade ve Arızalı Ürün",
          text: "İşlem değeri eksik.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else if (vm.islemTuru.value == "98" && vm.TEDARIKCIID == "") {
        vs.notify({
          title: "İade ve Arızalı Ürün",
          text: "Cari değerleri eksik.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        var yilsecilen = 1;

        if (vm.yil != "") yilsecilen = vm.yil.value;
        if (vm.islemturuVal == "") vm.islemturuVal = vm.islemTuru.value;

        var yildegeri = vm.getLastMonth(yilsecilen);

        var turofIslem = vm.islemTuru;
        var trtype = "";
        if (typeof turofIslem == "object") {
          turofIslem = vm.islemTuru.title;
        }

        if (turofIslem == "Rafta Arızalı" || turofIslem == "Satın Alma İade") {
          trtype = "201";
        } else {
          trtype = "101";
        }

        var args = {
          token: Store.state.tokenId,
          ACTID: vm.ACTID,
          TRANSTYPE: trtype,
          ARANAN: "",
          TARIH: yildegeri
        };
        if (turofIslem == "Rafta Arızalı" || turofIslem == "Satın Alma İade") {
          args = {
            token: Store.state.tokenId,
            ACTID: vm.TEDARIKCIID,
            TRANSTYPE: trtype,
            ARANAN: "",
            TARIH: yildegeri
          };
        }
        soap.createClient(url, function (err, client) {
          client.INT_IadeArizaliUrunSec(args, function (err, result) {
            if (result.INT_IadeArizaliUrunSecResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_IadeArizaliUrunSecResult);
              vm.rowData = vm.veriler;
            } catch (error) { }
          });
        });
      }
    },
    hareketList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      var args = {
        token: Store.state.tokenId,
        ISLEM: vm.islemTuru.title,
        RECEIPTID: vm.RECEIPTID
      };
      soap.createClient(url, function (err, client) {
        client.INT_IadeArizaliUrunHareket(args, function (err, result) {
          if (result.INT_IadeArizaliUrunHareketResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_IadeArizaliUrunHareketResult);
            vm.rowDataHareket = vm.veriler;
          } catch (error) { }
        });
      });
    },
    getPersonelList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId
      };
      soap.createClient(url, function (err, client) {
        client.INT_PersonelListesi(args, function (err, result) {
          if (result.INT_PersonelListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_PersonelListesiResult);
            vm.teslimAlanPersonel = vm.veriler;
          } catch (error) { }
        });
      });
    },
    autoSizeAll() {
      var skipHeader = true;
      const allColumnIds = [];
      /*  this.gridColumnApi.getColumns().forEach((column) => {
        allColumnIds.push(column.getId());
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);*/
    }
  },
  beforeRouteLeave(to, from, next) {
    const vs = this.$vs;
    vs.notify({
      text: "Sayfadan ayrılmak üzeresiniz, kalemler silinecektir.",
      iconPack: "feather",
      icon: "icon-alert-circle",
      color: "danger",
      position: "top-center"
    });

    var vm = this;
    const soap = require("soap");
    const url = state.sistemAddress;
    if (vm.rowDataSecilen.length > 0) {
      vm.rowDataSecilen.forEach((val, index) => {
        var args = {
          token: Store.state.tokenId,
          ID: val.ID
        };

        soap.createClient(url, function (err, client) {
          client.INT_IadeArizaliUrunSepetSil(args, function (err, result) {
            if (result.INT_IadeArizaliUrunSepetSilResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vm.veriler = JSON.parse(result.INT_IadeArizaliUrunSepetSilResult);
              //   console.log(vm.veriler)
            } catch (error) {
              vs.notify({
                title: "Sepet",
                text: "Ürün silinirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          });
        });
      });
    }
    next();
  },
  beforeMount() {
    this.columnDefsHareket = [
      {
        headerName: "Tarih",
        field: "TARIH",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params => this.parseDate(params.data.TARIH),
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Açıklama",
        field: "ACIKLAMA",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "İşlemi Yapan",
        field: "PERSONEL",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Durum",
        field: "DURUM",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Masraf",
        field: "TUTAR",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      }
    ];
    this.columnDefsSecilen = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "IadeArizaDetayFaturaSilButon"
      },
      {
        width: 100,
        field: "",
        cellRendererFramework: "IadeArizaDetaySepetResim"
      },
      {
        headerName: "Fiş No",
        field: "RECEIPTNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Tarih",
        field: "FTARIH",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Stok No",
        field: "STOCKNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Stok Adı",
        field: "STOCKNAME",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "iadeArizaStokAdiCellRenderer",
        autoHeight: true,
        wrapText: true
      },
      {
        headerName: "Seçilen",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "SECILEN",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Net Fiyat",
        field: "NETPRICE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params =>
          this.currencyFormatter(params.data.NETPRICE, "₺")
      }
    ];
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "IadeArizaDetayFaturaButton"
      },
      {
        headerName: "Fiş No",
        field: "RECEIPTNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Tarih",
        field: "TRANSDATE",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Stok No",
        field: "STOCKNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Stok Adı",
        field: "STOCKNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "iadeArizaStokAdiCellRenderer",
        autoHeight: true,
        wrapText: true,
        width: 450
      },
      {
        headerName: "Adet",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "QUANTITY",
        width: 75
      },
      {
        headerName: "Fiyat Farkı",
        field: "FIYATFARK",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "İade",
        field: "IADE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Arızalı",
        field: "ARIZALI",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Kalan",
        field: "KALAN",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },

      {
        headerName: "Net Fiyat",
        field: "NETPRICE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params =>
          this.currencyFormatter(params.data.NETPRICE, "₺")
      }
    ];
    this.columnDefsMulti = [
      {
        headerName: "Fiş No",
        field: "RECEIPTNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Tarih",
        field: "TRANSDATE",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Stok No",
        field: "STOCKNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Stok Adı",
        field: "STOCKNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Adet",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "QUANTITY",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "İade Adet",
        field: "IADEADET",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        editable: true
      },
      {
        headerName: "Fiyat Farkı",
        field: "FIYATFARK",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "İade",
        field: "IADE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Arızalı",
        field: "ARIZALI",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Kalan",
        field: "KALAN",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },

      {
        headerName: "Net Fiyat",
        field: "NETPRICE",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: params =>
          this.currencyFormatter(params.data.NETPRICE, "₺")
      }
    ];
  }
};
</script>
<style lang="scss">
[dir="ltr"] .b-sidebar.b-sidebar-right {
  width: 50%;
}

[dir="ltr"] .b-sidebar-outer {
  z-index: 11111111111111111111111111111111111;
}

[dir="ltr"] .autosuggest__results,
[dir="rtl"] .autosuggest__results {
  z-index: 1111111111111;
}

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

[dir] button:not(:disabled),
[dir] [type="button"]:not(:disabled),
[dir] [type="reset"]:not(:disabled),
[dir] [type="submit"]:not(:disabled) {
  cursor: pointer;
  border: none;
}

#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
  z-index: 1111111111111111111111111111;
}

[dir] .autosuggest__results .autosuggest__results-item {
  padding: 7px !important;
}

[dir] .card-text:last-child {
  color: black;
  font-weight: 500;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 1000000111111111111111111;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 200px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1)>.autosuggest__results-before {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}

[dir] #autosuggest__input {
  padding: 5px;
}
</style>
